import React, { useEffect } from "react";
import Table from 'react-bootstrap/Table';
import moment from 'moment';

const GapHeadway = (props) => {
    const {
        gap,
        setGap,
        counts,
        formatDate,
        avg_excluding_zeros,
     } = props

    // GAP & HEADWAY START
    // --------------------------
    useEffect(() => {
        // Gap & Headway
        const getGapHeadway = () => {

            let arr = [];

            //Filter Vehicles GAP,HEADWAY. Exclude PEDESTRIANS
            for (let i = 0; i < counts.length; i++){
                const gh = counts[i].entries
                    .map(obj => {return { 
                        date_iso: counts[i].date_iso, 
                        GAP: obj.GAP || 0, 
                        HEADWAY: obj.HEADWAY || 0 
                    }})
                    .filter(item => {return item.CLASS !== 'PEDESTRIAN'  && item.CLASS !== 'BIKE' && (item.GAP !== 0 || item.HEADWAY !== 0)})

                let avg = {}
                if (gh.length > 0)
                    avg = {
                        date_iso: gh[0].date_iso,
                        GAP: avg_excluding_zeros(gh.map(i => i.GAP)),
                        HEADWAY: avg_excluding_zeros(gh.map(i => i.HEADWAY))
                    } 
    
                if (avg.GAP || avg.HEADWAY)
                    arr = [...arr, avg];

                // if (gh.length > 0)
                //     arr = [...arr, gh[0]];
            }
            setGap(arr);
        }

        getGapHeadway();
    },[counts, avg_excluding_zeros, setGap]);
    // GAP & HEADWAY END


return (
    <div className="row p-2">
        <div className="col-md-12">
        <h2 className="text-header">Gap and Headway</h2>
        <div className="text-description small pb-3">
        {/* gap: measure of the time between the rear bumper of the first vehicle and the front bumper of the second vehicle (avg/hr)<br/>
        headway: distance between two vehicles (avg/hr) */}
        gap: average time passing between leaving of the first and entering of the second vehicle, not class specific (avg/hr) <br/>
        headway: average time passing between entering of the first and entering of the second vehicle, not class specific (avg/hr)
        </div>
        <div className="row">

            <div className="col-md-12">
            <Table responsive hover className="small p-0 border">
            <thead>
                <tr>
                <th className="table-th-det">Date</th>
                <th className="table-th-det">Time</th>
                <th className="table-th-det">Gap [s]</th>
                <th className="table-th-det">Headway [s]</th>
                </tr>
            </thead>
            <tbody>

            {gap.map((x, i) =>
            <tr key={i} className="table-tr">
                <td className="table-td">{ moment.utc(x.date_iso).local().format(formatDate[0])}</td>
                <td className="table-td">{
                parseInt(moment.utc(x.date_iso).local().format('HH'))+":00 - "
                + (parseInt(moment.utc(x.date_iso).local().format('HH'))+1)+":00"
                }</td>
                <td className="table-td">{x.GAP ? parseFloat(x.GAP).toFixed(2) : '-'}</td>
                <td className="table-td">{x.HEADWAY ? parseFloat(x.HEADWAY).toFixed(2) : '-'}</td>
            </tr>
            )}

            </tbody>
            </Table>
            </div>
        </div>
        </div>
    </div>
)}

export default GapHeadway;